import {Injectable} from "@angular/core"
import {MatDialog} from "@angular/material"
import {ErrorDialogComponent} from "app/common/services/error/dialog/ErrorDialogComponent"
import {Observable} from "rxjs"

@Injectable({providedIn: "root"})
export class ErrorService {

    public constructor(private dialog: MatDialog) {

    }

    public open(message: string, title: string = "Error"): Observable<void> {
        const data = {title, message}
        return this.dialog.open(ErrorDialogComponent, {disableClose: true, data}).afterClosed()
    }
}
